/**
 * Your bets module types.
 *
 * @class YourBetsTypes
 * @name types
 * @memberof Mojito.Modules.YourBets
 */
export default class YourBetsTypes {}

/**
 * Available your bet types.
 *
 * @typedef BETS_TYPE
 * @property {string} OPEN - List that contains user's open bets.
 * @property {string} LIVE - List that contains user's open bets which are currently live.
 * @property {string} SETTLED - List that contains user's settled bets.
 * @property {string} SAVED - List that contains user's saved bets. Can be present for "Build my bet" application types.
 * @property {string} SAVED_GLOBAL - List that contains global saved bets. Can be present for "Build my bet" application types.
 *
 * @memberof Mojito.Modules.YourBets.types
 */
YourBetsTypes.BETS_TYPE = {
    OPEN: 'OPEN',
    LIVE: 'LIVE',
    SETTLED: 'SETTLED',
    SAVED: 'SAVED',
    SAVED_GLOBAL: 'SAVED_GLOBAL',
};

/**
 * Available bet list tab types.
 *
 * @typedef BET_LIST_TAB_TYPE
 * @property {string} MY_BETS - Tab that contains user's saved bets.
 * @property {string} GLOBAL - List that contains global saved bets.
 *
 * @memberof Mojito.Modules.YourBets.types
 */
YourBetsTypes.BET_LIST_TAB_TYPE = {
    MY_BETS: 'MY_BETS',
    GLOBAL: 'GLOBAL',
};

/**
 * The state of the bet.
 *
 * @typedef BetState
 * @property {Map<string, Mojito.Modules.YourBets.types.LegState>} legsState - The map of leg states. Key is leg id and value is the state of the leg. Leg id is generated by {@link Mojito.Bets.utils.getLegId|getLegId} function.
 *
 * @memberof Mojito.Modules.YourBets.types
 */

/**
 * The state of the leg.
 *
 * @typedef LegState
 * @property {boolean} hasOddsChange - True if the leg has odds change, otherwise false.
 * @property {string} newOdds - The new odds. Available if odds have been changed for a particular leg. These odds are qual to selection odds for DEFAULT leg sorts.
 * @property {Mojito.Services.Bets.types.PRICE_TYPE} newPriceType - The new price type. Valuable for a cases when selection changed price type, e.g. From SP to LP for racing sports.
 * @property {boolean} isComposite - True if leg is composite of many selections, e.g. MATCH_ACCA, forecast, tricast etc.
 * @property {object} selection - The selection object. Available if leg is DEFAULT leg sort and has odds change.
 *
 * @memberof Mojito.Modules.YourBets.types
 */
